// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + {"168":"kyc-face-landmarker","703":"kyc-document-detector"}[chunkId] + "." + {"168":"a73a1a58","703":"e9851643"}[chunkId] + ".chunk.js";
};